import "./Header.scss";
import Button from "devextreme-react/button";
import { useAuth } from "../../../features/auth/context/authContext";
import { useNavigate } from "react-router-dom";
import { UserPanel } from "./component/UserPanel";
import { useSidebar } from "../sidebar/context/SidebarContext";
import Breadcrumb from "../breadcrumb/Breadcrumb";

export default function Header() {
    const sidebar = useSidebar()
    const navigate = useNavigate()
    const { isLoggedIn } = useAuth()

    return (
        <header className={"header-component"}>
            { isLoggedIn &&
                <Button className="menu-hamburger" icon="menu" stylingMode="text" onClick={sidebar.toggleSidebar} />
            }

            <div className="header-title" onClick={() => navigate("dashboard")}>
                <img className="header-logo" src="/care4check_logo.png" alt="" />
                { !sidebar.isXSmall &&
                    <span className="font-lato">Care4Check</span>
                }
            </div>

            { isLoggedIn &&
                <Breadcrumb />
            }

            { isLoggedIn &&
                <div className="right">
                    <UserPanel />
                </div>
            }
        </header>
    );
}
